import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Shield, Server, Zap, Globe } from 'lucide-react';

const badges = [
  { icon: Shield, labelDe: 'DSGVO-konform', labelEn: 'GDPR compliant', color: 'neon' },
  { icon: Server, labelDe: 'Server in Deutschland', labelEn: 'Servers in Germany', color: 'cyan' },
  { icon: Zap, labelDe: '99,9% Verfügbarkeit', labelEn: '99.9% Uptime', color: 'pink' },
  { icon: Globe, labelDe: 'Open Source', labelEn: 'Open Source', color: 'neon' },
];

export default function TrustBanner() {
  const { lang } = useLang();

  return (
    <section data-testid="trust-banner" className="py-12 bg-[#050505] relative overflow-hidden">
      {/* Subtle neon line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon/30 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {badges.map((badge, i) => {
            const Icon = badge.icon;
            const colorMap = {
              neon: 'border-neon/20 hover:border-neon/50 text-neon',
              cyan: 'border-cyan/20 hover:border-cyan/50 text-cyan',
              pink: 'border-pink/20 hover:border-pink/50 text-pink',
            };
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className={`flex items-center gap-3 lg:gap-4 bg-white/[0.02] backdrop-blur-sm border ${colorMap[badge.color]} rounded-2xl p-4 lg:p-5 transition-all duration-500 hover:-translate-y-1`}
              >
                <div className={`flex-shrink-0 w-10 h-10 lg:w-12 lg:h-12 rounded-xl bg-${badge.color}/10 flex items-center justify-center`}>
                  <Icon className={`w-5 h-5 lg:w-6 lg:h-6 ${colorMap[badge.color].split(' ')[2]}`} />
                </div>
                <span className="text-sm lg:text-base font-semibold text-white">
                  {lang === 'de' ? badge.labelDe : badge.labelEn}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-pink/20 to-transparent" />
    </section>
  );
}
